import { render, staticRenderFns } from "./PaymentMethodsModal.vue?vue&type=template&id=5c5509ff&scoped=true"
import script from "./PaymentMethodsModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsModal.vue?vue&type=style&index=0&id=5c5509ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5509ff",
  null
  
)

export default component.exports